import React from 'react'
import { useAuth } from '../utils/auth'
import AddToPcoButton, { SongSection } from './AddToPcoButton'
import PcoAuthButton from './PcoAuthButton'
import { Song } from '../__generated__/graphql'
import { ChordItem } from '../utils/songs/songTabsCommon'

interface PcoButtonProps {
  inList: boolean
  song: Song
  songStructure?: Array<SongSection>
  songKey: string
  chordCharts?: ChordItem[]
  capo?: string
}

/**
 * Wrapper component that conditionally shows:
 * - AddToPcoButton if user has active PCO account
 * - PcoAuthButton if user doesn't have active PCO account
 */
const PcoButton: React.FC<PcoButtonProps> = (props) => {
  const { currentUser } = useAuth()
  const hasActivePCOAccount = Boolean(currentUser?.pcoAccountId)

  if (!props.song.ccliNumber) {
    return <></>
  }

  if (hasActivePCOAccount) {
    return <AddToPcoButton {...props} />
  } else {
    return <PcoAuthButton inList={props.inList} />
  }
}

export default PcoButton
export type { SongSection }
